import { render, staticRenderFns } from "./FormSearch.vue?vue&type=template&id=a5fe760a"
import script from "./FormSearch.vue?vue&type=script&lang=js"
export * from "./FormSearch.vue?vue&type=script&lang=js"
import style0 from "./FormSearch.vue?vue&type=style&index=0&id=a5fe760a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports